module.exports = __webpack_public_path__ + "static/abdolmalekico-complete-97588747e606621d624b44b06949170d.jpg";